import { render, staticRenderFns } from "./TeamListText.vue?vue&type=template&id=606c1075&"
import script from "./TeamListText.vue?vue&type=script&lang=js&"
export * from "./TeamListText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports